import React from 'react'
import { ourFeatures } from '../../constants';

function WhyUs() {
  return (
    <section id='why-us' className='background-gradient'>
      <div className="container text-center">
        <div className='mb-5'>
          <h2 className='mb-3'>Kenapa harus kami ?</h2>
          <p className='desc'>Keunggulan Black Canyon Transport, Rental mobil murah dan berkualitas di kota Palu</p>
        </div>
        <div className="d-flex justify-content-center flex-wrap align-items-center" style={{columnGap: "30px", rowGap: "30px"}}>
          {
            ourFeatures.map(feature => {
              return(
                <div 
                  className=" p-3 text-start card-testimoni" 
                  style={{height: "21rem", width: "21rem"}}
                  key={feature.id} 
                  data-aos="flip-left" 
                  data-aos-duration="1000"
                >
                  <div className="card-body text-center">
                    <img src={feature.src} alt="testimonial" className='mb-4' style={{borderRadius: "50%", border: "3px solid #222"}}/>
                    <h5 className="card-title mb-3">{feature.title}</h5>
                    <p className="card-text">{feature.desc}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

export default WhyUs